import { get, URLs } from './request';

export const searchRestaurants = async ({ addressId, geoLocation, time = 'asap' }) => {
  const query = addressId
    ? {
      address_id: addressId,
      time,
    }
    : {
      latitude: geoLocation.lat,
      longitude: geoLocation.lng,
      time,
    };
  const { data } = await get({
    url: `${URLs.api}/pickup/v2/restaurants`,
    options: { CORS_API: true },
    data: {
      query,
    },
  });
  return data;
};
